import { useState } from "react";
import { api, dt } from "../../lib/api";
import { useLoad, act, Card, Badge, H1, Table, abtn } from "../../components/admin/ui";

export default function Agents() {
  const [agents, reload] = useLoad("/admin/agents");
  const [sel, setSel] = useState("");
  const [runs, reloadRuns] = useLoad("/admin/runs", { agent: sel });
  const [busy, setBusy] = useState("");
  const run = async (a) => {
    setBusy(a.key);
    const r = await act(() => api.post(`/admin/agents/${a.key}/run`, {}, { timeout: 180000 }));
    if (r) act(async () => null, `${a.name} : ${r.status}${r.error ? ` — ${r.error}` : ""}`);
    setBusy(""); reload(); reloadRuns();
  };
  return (
    <div>
      <H1 sub="13 agents au périmètre défini, permissions minimales et limites de dépense. Aucun agent ne peut modifier ses permissions, ses limites ou les interrupteurs. Les agents Créatif et Localisation appellent Claude (coût réel) et ne sont déclenchés que manuellement.">Agents IA</H1>
      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4 mb-8">
        {(agents || []).map((a, i) => (
          <div key={a.key} className="admin-card p-5 flex flex-col rise" style={{ animationDelay: `${i * 30}ms` }} data-testid={`ai-agent-card-${a.key}`}>
            <div className="flex justify-between items-start">
              <div className="font-semibold">{a.name}</div>
              {a.last_run && <Badge v={a.last_run.status} testid={`agent-last-status-${a.key}`} />}
            </div>
            <div className="text-xs text-slate-400 mt-2 flex-1">{a.scope}</div>
            <div className="text-[10px] font-mono text-slate-500 mt-3">N{a.level} · {a.permissions.join(", ")} · limite {a.spend_limit_eur == null ? "plafonds globaux" : `${a.spend_limit_eur} €`}{a.kill ? ` · kill:${a.kill}` : ""}</div>
            <div className="text-[10px] font-mono text-slate-500 mt-1">{a.runs} exécutions · {a.interval ? `toutes les ${a.interval}s` : "manuel"} · {dt(a.last_run?.started_at)}</div>
            <div className="flex gap-2 mt-4">
              <button data-testid={`agent-run-${a.key}`} disabled={busy === a.key} onClick={() => run(a)} className={abtn}>{busy === a.key ? "Exécution…" : "Exécuter"}</button>
              <button data-testid={`agent-logs-${a.key}`} onClick={() => setSel(a.key)} className={abtn}>Journal</button>
            </div>
          </div>
        ))}
      </div>
      <Card title={`Journal d'exécution ${sel ? `· ${sel}` : "· tous agents"}`} right={sel && <button onClick={() => setSel("")} className={abtn}>Tous</button>}>
        <Table testid="agent-runs-table" rows={runs || []} cols={[
          ["Début", (r) => <span className="font-mono text-xs">{dt(r.started_at)}</span>], ["Agent", (r) => r.agent], ["Déclencheur", (r) => <span className="text-xs">{r.trigger}</span>],
          ["Statut", (r) => <Badge v={r.status} />], ["Durée", (r) => <span className="font-mono text-xs">{r.duration_ms ?? "—"} ms</span>],
          ["Sortie", (r) => <span className="font-mono text-[11px] text-slate-400 break-all">{r.error || JSON.stringify(r.output || {}).slice(0, 220)}</span>],
        ]} />
      </Card>
    </div>
  );
}
